import React from 'react';

const LoadingSpinner = ({ loadingText }) => {
    return (
        <div>
            <div className="spinner-backdrop"></div>
            <div className="spinner-container">
                <div className="spinner-card">
                    <div className="spinner"></div>
                    <div className="spinner-text">
                        <h2>{loadingText}</h2>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoadingSpinner;